import axios from 'axios';
import { useMutation } from 'react-query';

export type DisintegrateResponse = {
  code: string;
  message: string;
};

const disintegrateMerchant = async (
  merchantId: string,
): Promise<DisintegrateResponse> => {
  const { data } = await axios.post(
    `/api/merchants/${merchantId}/disintegrate`,
  );
  return data;
};

export const useDisintegrate = ({ onSuccess, onError }) => {
  return useMutation(disintegrateMerchant, {
    onSuccess,
    onError,
  });
};
